// extracted by mini-css-extract-plugin
export default {"container":"ui-z","blurb":"vi-z","links":"wi-z"};